export const arrayFilter = (array, val) => {
  return array.filter((el) => {
    return el.key === val;
  });
};

export const arrayFilterByControl = (array, objName, val) => {
  return array.filter((el) => {
    return el[objName] === val;
  });
};

export const arrayFilterByObjectCondition = (
  array,
  objName,
  objValue,
  objCondition
) => {
  let results = array
    .filter((el) => el[objName] === objValue)
    .map((el) => el[objCondition]);
  return results[0];
};

export const arrayFilterByTest = (array, val) => {
  return array.filter((el) => {
    return el.testName === val;
  });
};

export const arrayFilterByColumn = (array, val) => {
  return array.filter((el) => {
    return el.columnName === val;
  });
};

export const getDropDownDetails = (arr) => {
  arr.forEach((element) => {
    element.value = element.testSuiteName;
    element.label = element.testSuiteName;
    element.key = element.testSuiteName;

    delete element.testSuiteName;
    delete element.testSuiteId;
    delete element.controlDocumentName;
    delete element.testSuiteType;
    delete element.createdBy;
    delete element.updatedDate;
    delete element.updatedBy;
    delete element.createdDate;
    delete element.comments;
    delete element.labels;
    delete element.testCaseCount;
  });
  let updatedArray = JSON.stringify(arr);
  return updatedArray;
};

export const parseToJson = (arr) => {
  return JSON.parse(arr);
};

export const transformData = (data) => {
  if (!Array.isArray(data)) {
    return [];
  }
  return data.map((item) => {
    const transformedItem = {
      title: item.name,
      key: item.id,
      children: item.children ? transformData(item.children) : [],
    };
    return transformedItem;
  });
};

export const transformDataCustom = (data) => {
  if (!Array.isArray(data)) {
    return [];
  }
  return data.map((item) => {
    const transformedItem = {
      title: item.name,
      key: item.id,
      disabled: item.disabled || false,
    };
    if (item.children) {
      transformedItem.children = transformDataCustom(item.children);
    }
    return transformedItem;
  });
};

export const simpleArrayToTree = (data) => {
  const parent = [
    {
      name: "Column Level",
      id: "1",
      disabled: false,
    },
  ];
  const child = data.map((item, index) => ({
    name: item.substring(0, item.indexOf("-")),
    id: `1-${index}`,
    disabled: JSON.parse(item.substring(item.indexOf("-") + 1)),
  }));
  parent[0].children = child;
  return parent;
};

export const changeValueOfObject = (array, object, value) => {
  array.map((item) => {
    return { ...item, object: value };
  });
};

export const checkElementArrayObjArray = (arrObj, array, key) => {
  return arrObj.every((item) => array.includes(item[key]));
};
